module.exports = __webpack_public_path__ + "img/dashboard_blue.2fbbff58.svg";